import { Grid, Typography, useMediaQuery } from '@mui/material';
import { Theme } from '@mui/material/styles';
import React, { FC, ReactElement } from 'react';

export const AboutBlock: FC = (): ReactElement => {
  const isMobile: boolean = useMediaQuery((theme: Theme): string => theme.breakpoints.down('sm'));

  return (
    <Grid container={true} direction={'column'} spacing={isMobile ? 2 : 5}>
      <Grid item={true}>
        <Typography variant={'h1'}>{'О сервисе'}</Typography>
      </Grid>
      <Grid item={true}>
        <Typography variant={'body1'}>
          {'Служба отправки сообщений работает с 1 декабря 2008 года на базе исправительных учреждений России,' +
            ' в соответствии с действующими законами и инструкциями РФ, регламентирующими данный вид деятельности.' +
            ' Сервис предназначен для отправки электронных сообщений с уведомлением о вручении лицам,' +
            ' находящимся в следственных изоляторах или отбывающим наказание в местах лишения свободы.'}
        </Typography>
      </Grid>
    </Grid>
  );
};
